import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection} from '@angular/fire/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})

export class GroupsService {

  private collectionGroups:AngularFirestoreCollection;

  constructor(public afAuth: AngularFireAuth, private firestore: AngularFirestore) {
  }

  public createGroup(data: any) {
    return this.firestore.collection('groups').add(data);
  }

  public getGroup(documentId: string) {
    return this.firestore.collection('groups').doc(documentId).snapshotChanges();
  }

  public getGroups() {
    const luser = localStorage.getItem('userEmail').replace(/['"]+/g, '');
    return this.firestore.collection('groups', ref => ref.where('usuarios', 'array-contains', luser)).snapshotChanges();
  }

  public updateGroup(documentId: string, data) {
    return this.firestore.collection('groups').doc(documentId).update(data);
  }

  public deleteGroup(documentId: string) {
    return this.firestore.collection('groups').doc(documentId).delete();
  }

}
